export function addToBasketAction(href) {
  function hideBasketMessage(elem) {
    if (!elem) return;
    setTimeout(function () {
      elem.classList.remove("active");
      const addAllBtn = document.getElementById("addAllChips");
      if (addAllBtn) {
        addAllBtn.classList.remove("transparent");
        const addAllBtnLoader = document.querySelector(".loader");
        if (addAllBtnLoader) {
          addAllBtnLoader.style.display = "none";
        }
      }
    }, 5000);
  }

  fetch(href, {
    // The basket surface actions are POST-only so crawlers following GET links
    // cannot create orders (see docs/thread-pool-starvation.md).
    method: "POST",
    headers: {
      "X-Requested-With": "XMLHttpRequest",
    },
  })
    .then((response) => response.json())
    .then((data) => {
      document
        .querySelectorAll(".site-header__cart-count")
        .forEach((element) => {
          element.innerHTML = data.totalItems;
        });

      const basketNotificationMessage = document.querySelector(
        ".basket-notification"
      );
      if (basketNotificationMessage) {
        basketNotificationMessage.classList.add("active");
        const basketNotificationMessageContent =
          basketNotificationMessage.querySelector(".content p");
        if (basketNotificationMessageContent) {
          basketNotificationMessageContent.textContent = data.message;
        }
        const basketNotificationMessageIcon =
          basketNotificationMessage.querySelector(".icon-chip");
        if (basketNotificationMessageIcon) {
          basketNotificationMessageIcon.style.color = data.iconColour;
        }
        hideBasketMessage(basketNotificationMessage);
      }

      const basketElem = document.querySelector(".basket");
      if (data.basket != "" && basketElem) {
        basketElem.innerHTML = data.basket;
      }

      const addAllBtn = document.getElementById("addAllChips");
      if (addAllBtn) {
        addAllBtn.classList.remove("transparent");
        const addAllBtnLoader = document.querySelector(".loader");
        if (addAllBtnLoader) {
          addAllBtnLoader.style.display = "none";
        }
      }
    })
    .catch((error) => {
      const basketNotificationMessage = document.querySelector(
        ".basket-notification"
      );
      if (basketNotificationMessage) {
        basketNotificationMessage.classList.add("active-error");
        const basketNotificationMessageContent =
          basketNotificationMessage.querySelector(".content");
        if (basketNotificationMessageContent) {
          basketNotificationMessageContent.textContent = data.message;
        }

        hideBasketMessage(basketNotificationMessage);
      }

      const addAllBtn = document.getElementById("addAllChips");
      if (addAllBtn) {
        addAllBtn.classList.remove("transparent");
        const addAllBtnLoader = document.querySelector(".loader");
        if (addAllBtnLoader) {
          addAllBtnLoader.style.display = "none";
        }
      }
    });
}
